import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@kontentino/ui';
import clsx from 'clsx';
import { SettingsSidebarItem as SettingsSidebarItemConfig } from './settingsSidebarItems';

interface SettingsSidebarItemProps {
  item: SettingsSidebarItemConfig;
}

const baseClassName =
  'tw-flex tw-items-center tw-gap-2 tw-h-8 tw-px-2 tw-py-[6px] tw-rounded tw-text-sm tw-font-medium tw-text-grayscale-180 hover:tw-bg-grayscale-10';

export const SettingsSidebarItem = ({ item }: SettingsSidebarItemProps) => {
  const { t } = useTranslation();

  if (item.isExternal) {
    return (
      <a
        href={item.to}
        target="_blank"
        rel="noopener noreferrer"
        className={baseClassName}
        data-cy={`settings_sidebar_${item.key}`}
      >
        <Icon icon={item.icon} size="sm" className="tw-text-grayscale-100" />
        <span>{t(item.label)}</span>
      </a>
    );
  }

  return (
    <NavLink
      to={item.to}
      className={({ isActive }) =>
        clsx(baseClassName, isActive && 'tw-bg-primary-10 tw-text-primary-100')
      }
      data-cy={`settings_sidebar_${item.key}`}
    >
      {({ isActive }) => (
        <>
          <Icon
            icon={item.icon}
            size="sm"
            className={
              isActive ? 'tw-text-primary-100' : 'tw-text-grayscale-100'
            }
          />
          <span>{t(item.label)}</span>
        </>
      )}
    </NavLink>
  );
};
